import { axiosClient } from "./axiosClient"

export const COLOR_PATH = '/api/v1/color'

export const addColor = (body) => {
    return axiosClient.post(COLOR_PATH, body)
}

export const updateColor = (id, body) => {
    return axiosClient.put(`${COLOR_PATH}/${id}`, body)
}

export const deleteColor = (id) => {
    return axiosClient.delete(`${COLOR_PATH}/${id}`)
}

export const getColorById = (id) => {
    return axiosClient.get(`${COLOR_PATH}/${id}`)
}

export const getPageColors = ({ page, size = 20, search = '', lastId = '', id = "", code = '', name = '', hexCode = '' }) => {
    return axiosClient.get(`${COLOR_PATH}/page?page=${page}&size=${size}&search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}&hexCode=${hexCode}`)
}

export const uploadColorExcelFile = (body) => {
    return axiosClient.post(`${COLOR_PATH}/upload-excel`, body)
}

export const downloadColorExcelFile = () => {
    return axiosClient.get(`${COLOR_PATH}/download-excel`, {
        responseType: 'arraybuffer',
    })
}